import { createContext } from 'react';

export const RedirectContext = createContext({});
